<template>
  <inner
    @apply="applyFilter"
    @clear="clear"
  >
    <custom-select-price-dropdown-content
      class="panel-content"
      @update-price="updatePrice"
      :from="from"
      :to="to"
      :min="minMax.min.toString()"
      :max="minMax.max.toString()"
    />
  </inner>
</template>

<script>
import CustomSelectPriceDropdownContent from '@kit/custom-select/custom-select-price-dropdown-content.vue';
import priceFilterMixin from '@/components/filters/price-filter-mixin';
import Inner from '@/components/mobile-multiselect/inner.vue';

export default {
  components: {
    Inner,
    CustomSelectPriceDropdownContent
  },

  mixins: [priceFilterMixin]
}
</script>

<style lang="scss">
  .custom-select-price-dropdown-content.panel-content {
    width: auto;
    padding: 16px;
  }
</style>